module.exports = __webpack_public_path__ + "static/media/100-organic.390a69da.png";